import { SimpleTag as Tag } from '@atlaskit/tag';

import { TestOutcomeEnum } from '../types';
import { getTagColor } from '../utils';

interface TestOutcomeProps {
  type: TestOutcomeEnum;
}

export const TestOutcome = ({ type }: TestOutcomeProps) => {
  const tagText = Object.keys(TestOutcomeEnum).find(
    key => (TestOutcomeEnum as any)[key] === type
  ) as string;

  return <Tag text={tagText} color={getTagColor(type)} />;
};
